const urls = {
  activity: 'https://lol.qq.com/act/a20181207snow/index.html?e_code=435875',
  newSkin: 'http://lol.qq.com/act/a20181207snow/index.html?e_code=442728#cont5',
}

export default urls
